module.exports = __webpack_public_path__ + "img/photo.54bcb136.svg";